import React, { useState, useContext } from "react"

import GeoLocation from "@/icons/geo-location.svg"
import Arrow from "@/icons/arrow.svg"
import { useTranslation } from "@zestia/gatsby-plugin-react-i18next"
import { RegionContext } from "@/context/region"

const RegionSelect = () => {
  const { t } = useTranslation()

  const { region, setRegion } = useContext(RegionContext)

  let Regions = {
    GB: { text: t("footer.regions.GB") },
    EU: { text: t("footer.regions.EU") },
    US: { text: t("footer.regions.US") },
  }

  const regionCodes = Object.keys(Regions)

  const [isSelectorOpen, setIsSelectorOpen] = useState(false)

  const handleRegionOptionClick = selectedRegion => {
    setRegion(selectedRegion)

    setIsSelectorOpen(false)
    window.scrollTo({ top: 0 })
  }

  return (
    <button
      onClick={() => setIsSelectorOpen(!isSelectorOpen)}
      className="mt-4 footer-secondary__region"
    >
      <GeoLocation />
      <span className="p--sm footer-secondary__region-selected">
        {region && Regions[region].text}
      </span>
      <span
        className={`footer-secondary__region-arrow ${
          isSelectorOpen ? "footer-secondary__region-arrow--rotate" : ""
        }`}
      >
        <Arrow />
      </span>

      <div
        className={`footer-secondary__region-bubble ${
          isSelectorOpen ? "footer-secondary__region-bubble--open" : ""
        }`}
      >
        <p className="mb-0">{t("common.change-to")}</p>
        {regionCodes.map(regionCode => (
          <p key={regionCode} className="mb-0 p--sm">
            <span
              className="footer-secondary__region-option"
              onClick={() => handleRegionOptionClick(regionCode)}
            >
              {Regions[regionCode].text}
            </span>
          </p>
        ))}
      </div>
    </button>
  )
}

export default RegionSelect
